import { type } from "../../types/types";

export default function reducer(
  state = { screenWidth: "", isLoading: false },
  action
) {
  switch (action.type) {
    case type.SET_WIDTH:
      return { ...state, screenWidth: action.width };
    case type.SET_LOADING:
      return { ...state, isLoading: action.isLoading };
    default:
      return state;
  }
}
